import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { POWERUPS } from '../economy/economyCatalog';
import CoinIcon from './icons/CoinIcon';
import AddCoinsPill from './coins/AddCoinsPill';
import './InspectButton.css';

const InspectButton = ({
  onInspect,
  disabled,
  freeInspectsRemaining = 0,
  onBlockedClick,
}) => {
  const { coins } = useProfile();
  const [isProcessing, setIsProcessing] = useState(false);
  const INSPECT_COST = POWERUPS.inspect.uiCostCoins;

  const handleInspect = async () => {
    if (disabled || isProcessing) {
      return;
    }

    if (freeInspectsRemaining <= 0 && coins < INSPECT_COST) {
      onBlockedClick?.();
      return;
    }

    setIsProcessing(true);
    try {
      await onInspect();
    } finally {
      setIsProcessing(false);
    }
  };

  const canAfford = freeInspectsRemaining > 0 || coins >= INSPECT_COST;
  const showAddCoins = freeInspectsRemaining <= 0 && coins < INSPECT_COST;

  const costLabel =
    freeInspectsRemaining > 0 ? `Free: ${freeInspectsRemaining}` : null;
  const costClass =
    freeInspectsRemaining > 0 ? 'cost-indicator free' : 'cost-indicator';

  const disableMainAction = !canAfford || disabled || isProcessing;
  // IMPORTANT: when user is broke, don't use the HTML "disabled" attribute,
  // otherwise the embedded "Add Coins" pill cannot be clicked.
  const useNativeDisabled = disableMainAction && !showAddCoins;

  return (
    <div className="inspect-button-wrap">
      <button
        className={`inspect-button ${disableMainAction ? 'disabled' : ''} ${showAddCoins ? 'add-coins-state' : ''}`.trim()}
        onClick={handleInspect}
        disabled={useNativeDisabled}
        aria-disabled={disableMainAction}
      >
        <span className="label">{isProcessing ? 'Inspecting...' : 'Inspect'}</span>
        {costLabel ? (
          <span className={costClass}>{costLabel}</span>
        ) : (
          <span className={costClass}>
            {INSPECT_COST}
            <CoinIcon />
          </span>
        )}

        {showAddCoins && <AddCoinsPill className="cost-indicator add-coins-pill" />}
      </button>
    </div>
  );
};

export default InspectButton; 